/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const CircleParkingOff = [
  ["path", { d: "M12.656 7H13a3 3 0 0 1 2.984 3.307" }],
  ["path", { d: "M13 13H9" }],
  ["path", { d: "M19.071 19.071A1 1 0 0 1 4.93 4.93" }],
  ["path", { d: "m2 2 20 20" }],
  ["path", { d: "M8.357 2.687a10 10 0 0 1 12.956 12.956" }],
  ["path", { d: "M9 17V9" }]
];

export { CircleParkingOff as default };
//# sourceMappingURL=circle-parking-off.js.map
